import Images from './constants/Images';

export const cardDetails = [
  {
    id: 1,
    uid: 'b0a5fd79-c390-45d5-91bc-1d3e64bf6544',
    name: 'Sunny', //
    role: 'Co-Founder', //
    phone: '+1 267-271-8938',
    email: 'sunny@bcpinc.us', //
    address: 'PO BOX 32, Spotswood, NJ 08844-0032', //
    website: 'www.bcpinc.us', //
    infoEmail: 'info@bcpinc.us',
    altPhone: '+1 877-540-5678',
    photo: Images.sunny,

    themeColor: '#0C63AB',
  },
  {
    id: 2,
    uid: '9ab130e3-c682-41b6-b7be-2b3d1a56a4a0',
    name: 'Partha Radadiya', //
    role: 'Director, Regulatory & Compliance', //
    phone: '+1 267-251-9998',
    email: 'parth@bcpinc.us', //
    address: 'PO BOX 32, Spotswood, NJ 08844-0032', //
    website: 'www.bcpinc.us', //
    infoEmail: 'info@bcpinc.us',
    altPhone: '+1 877-540-5678',
    photo: Images.parth,
    background: Images.bcpLogo,
    themeColor: '#0C63AB',
  },
  // {
  //   id: 3,
  //   uid: '8f60a712-6b55-476c-908b-9196e6a5ec76',
  //   name: 'Christopher Gardner', //
  //   role: 'Sales Executive', //
  //   phone: '+1 201-780-8676',
  //   email: 'chris.gardner@bcpinc.us', //
  //   address: 'PO BOX 32, Spotswood, NJ 08844-0032', //
  //   website: 'www.bcpinc.us', //
  //   infoEmail: 'info@bcpinc.us',
  //   altPhone: '+1 877-540-5678',
  //   photo: Images.chris,
  //   background: Images.bcpLogo,
  //   themeColor: '#0C63AB',
  // },
];
